export const environment = {
  production: true,
  apiHostname: 'https://api.maviepro.net',
  apiUrl: 'https://api.maviepro.net/v2',
  assetUrl: 'https://maviepro.s3.rbx.io.cloud.ovh.net/public',
  socketUrl: 'https://api.socket.maviepro.net',
  application: 'tract'
};
